import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import Paper from "@material-ui/core/Paper";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import { useWindowSize } from "hooks/screen";
import useStyles from "./styles";

export interface Props {
  className?: string;
  items: unknown[];
  itemRenderer: (item: any) => React.ReactNode;
  onSlideChange?: (index: number) => void;
  activeSlide?: number;
}

const PaperCarousel = (props: Props) => {
  const { className, items, itemRenderer, onSlideChange, activeSlide } = props;
  const classes = useStyles();
  const rootRef = useRef<HTMLDivElement>();
  const [itemWidth, setItemWidth] = useState<number>(window.innerWidth - 32);
  const { width } = useWindowSize();

  const handleSlideChange = index => {
    onSlideChange && onSlideChange(index);
  };

  useEffect(() => {
    if (rootRef.current) {
      setItemWidth(rootRef.current.offsetWidth - 32);
    }
  }, [width, rootRef]);

  return (
    <div ref={rootRef} className={clsx(classes.root, className)}>
      <Carousel
        offset={8}
        value={activeSlide}
        itemWidth={itemWidth}
        onChange={handleSlideChange}
      >
        {items.map((item, i) => (
          <Paper key={i} className={classes.slide}>
            {itemRenderer(item)}
          </Paper>
        ))}
      </Carousel>
    </div>
  );
};

export default PaperCarousel;
